/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useEffect, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { HomePageEvent, useHomePageDataSelector } from ".";
import { useMainPageDataSelector } from "../../MainUi";
import SecondHeader from "../../Common/SecondHeader";
import TopContainer from "./TopContainer";
import AppSuggestions from "../../Common/AppSuggestions";
import AppGutterHomePage from "./AppGutterHomePage";
import Arrow from "../../Common/element/Arrow";
import Banner from "./Banner";
import NoResultsFound from "../../Common/NoResultsFound";
import { CLASSIFICATION } from "../../../constants";
import { LoadingStatus } from "../../../rootReducer/actions";
import ErrorPage from "../ErrorPage";
import * as configData from "../../../config.json";
import LoaderPage from "../../Common/LoaderPage";

export default function HomePage() {
  const dispatch = useDispatch();
  const pageData = useHomePageDataSelector();
  const mainPageData = useMainPageDataSelector();

  useEffect(() => {
    dispatch({
      type: HomePageEvent.GET_NEW_APPS_DATA,
      payload: {
        specification: CLASSIFICATION.NEWLY_ADDED,
        pageNo: 1,
        pageSize: 12,
      },
    });
    dispatch({
      type: HomePageEvent.GET_TOP_RATED_APPS_DATA,
      payload: {
        specification: CLASSIFICATION.TOP_RATED,
        pageNo: 1,
        pageSize: 6,
      },
    });
    dispatch({
      type: HomePageEvent.GET_MOST_USED_APPS_DATA,
      payload: {
        specification: CLASSIFICATION.MOST_USED,
        pageNo: 1,
        pageSize: 6,
      },
    });
    dispatch({
      type: HomePageEvent.GET_CAROUSEL_DATA,
    });
    dispatch({
      type: HomePageEvent.GET_APP_OF_THE_WEEK,
    });
  }, [dispatch]);

  useLayoutEffect(() => {
    // effect
    mainPageData.authState === true &&
      dispatch({
        type: HomePageEvent.GET_EDITOR_RECOMMENDED_APPS_DATA,
        payload: {
          msisdn: mainPageData.appUser.msisdn
            ? mainPageData.appUser.msisdn
            : null,
        },
      });
  }, [dispatch, mainPageData.appUser.msisdn, mainPageData.authState]);

  return (
    <>
      {pageData.loadingStatus === LoadingStatus.LOADING_ERROR ? (
        <ErrorPage />
      ) : (
        <>
          <TopContainer />
          <SecondHeader key="homepage" />
          <div className="container">
            {pageData.newlyAddedApps !== undefined ? (
              pageData.newlyAddedApps?.length !== 0 ? (
                <>
                  <AppGutterHomePage
                    key={configData.MAIN_TITLES.NEWLY_ADDED}
                    mainHeading={configData.MAIN_TITLES.NEWLY_ADDED}
                    subHeading={configData.SUB_TITLES.APPS}
                    note={configData.INTRO.NEW}
                    data={pageData.newlyAddedApps}
                  />
                  <Arrow link="/new-apps" />
                </>
              ) : (
                <NoResultsFound />
              )
            ) : (
              <LoaderPage />
            )}
            <Banner />
          </div>
          <div className="container">
            {pageData.topRatedApps !== undefined ? (
              pageData.topRatedApps?.length !== 0 ? (
                <>
                  <AppGutterHomePage
                    key={configData.MAIN_TITLES.TOP_RATED}
                    mainHeading={configData.MAIN_TITLES.TOP_RATED}
                    subHeading={configData.SUB_TITLES.APPS}
                    note={configData.INTRO.TOP_RATED}
                    data={pageData.topRatedApps}
                  />
                  <Arrow link="/top-rated-apps" />
                </>
              ) : (
                <NoResultsFound />
              )
            ) : (
              <LoaderPage />
            )}
            {pageData.mostUsedApps !== undefined ? (
              pageData.mostUsedApps?.length !== 0 ? (
                <>
                  <AppGutterHomePage
                    key={configData.MAIN_TITLES.MOST_USED}
                    mainHeading={configData.MAIN_TITLES.MOST_USED}
                    subHeading={configData.SUB_TITLES.APPS}
                    note={configData.INTRO.MOST_USED}
                    data={pageData.mostUsedApps}
                  />
                  <Arrow link="/most-used-apps" />
                </>
              ) : (
                <NoResultsFound />
              )
            ) : (
              <LoaderPage />
            )}
            {mainPageData.authToken &&
              (pageData.recommendedApps !== undefined ? (
                pageData.recommendedApps?.length !== 0 ? (
                  <AppSuggestions
                    title={configData.MAIN_TITLES.EDITORS_CHOICE}
                    apps={pageData.recommendedApps}
                  />
                ) : (
                  <NoResultsFound />
                )
              ) : (
                <LoaderPage />
              ))}
          </div>
        </>
      )}
    </>
  );
}
